import React from 'react'
import { DAY_BITS, DAY_ORDER } from '../types/dimmingProfile.types'
import { DimmingProfileUiStrings } from '../i18n/dimmingProfileI18n'

interface ActiveDaysSelectorProps {
  activeDays: number
  onToggle: (bit: number) => void
  strings: DimmingProfileUiStrings
  disabled?: boolean
}

// Checkbox row for the active-days bitfield (holiday/mon..sun).
const ActiveDaysSelector: React.FC<ActiveDaysSelectorProps> = ({
  activeDays,
  onToggle,
  strings,
  disabled = false,
}) => {
  return (
    <fieldset
      disabled={disabled}
      style={{
        border: '1px solid #e5e7eb',
        borderRadius: 6,
        padding: '8px 12px',
        margin: 0,
      }}
    >
      <legend style={{ fontSize: 13, fontWeight: 600, color: '#374151', padding: '0 6px' }}>
        {strings.activeDays}
      </legend>
      <div style={{ display: 'flex', flexWrap: 'wrap', gap: 12 }}>
        {DAY_ORDER.map((day) => {
          const bit = DAY_BITS[day]
          const checked = (activeDays & bit) !== 0
          return (
            <label
              key={day}
              style={{
                display: 'flex',
                alignItems: 'center',
                gap: 4,
                fontSize: 13,
                color: '#1f2937',
                cursor: disabled ? 'default' : 'pointer',
              }}
            >
              <input
                type="checkbox"
                checked={checked}
                onChange={() => onToggle(bit)}
              />
              {strings.day[day]}
            </label>
          )
        })}
      </div>
    </fieldset>
  )
}

export default ActiveDaysSelector
